<script>
import { stripePriceToString } from "~/stripe.utils.mjs";

import StripeThankYouError from "./StripeThankYouError.vue";
import StripeThankYouOk from "./StripeThankYouOk.vue";
import StripeThankYouStillProcessing from "./StripeThankYouStillProcessing.vue";

export default {
  translate25Context: 'stripe',
  components: {
    StripeThankYouError,
    StripeThankYouOk,
    StripeThankYouStillProcessing,
  },
  props: ["component", "handler"],
  computed: {
    amountDue() {
      return stripePriceToString(this.component.amount_due);
    },
    amountPaid() {
      return stripePriceToString(this.component.amount_paid);
    },
    orderStillProcessing() {
      // return false;
      return this.component.invoice_status !== "paid";
    },
    orderProcessingError() {
      return this.component.order_status === "error"
    }
  },
};
</script>
<template>
  <div class="stripe-thank-you">
    <f-sexy-scroll>
      <div class="stripe-thank-you-content">
        <FFadeTransitionOutIn>
          <div class="main-title" v-if="orderProcessingError">{{ $vt('An error occured while processing your order') }}</div>
          <div class="main-title" v-else-if="orderStillProcessing">{{ $vt('Processing your order') }}</div>
          <div class="main-title" v-else>{{ $vt('Thank you') }}</div>
        </FFadeTransitionOutIn>
        <div class="stripe-thank-you-detail">
          <component v-if="component.plan" v-bind:is="component.plan.meta.type" :component="component.plan"
            :handler="handler" :chosen="true">
          </component>
          <PlanExtraHoursPanel v-if="component.hours" :count="component.hours.quantity"
            :hour-price="component.hours.unit_amount" />
          <div class="stripe-thank-you-information" :pending="orderStillProcessing">

            <FFadeTransitionOutIn>
              <StripeThankYouError :component="component" v-if="orderProcessingError" />
              <StripeThankYouStillProcessing :component="component" v-else-if="orderStillProcessing" />
              <StripeThankYouOk :component="component" v-else />
            </FFadeTransitionOutIn>


            <div class="center-spacer">
              <div class="spacer"></div>
            </div>
            <div class="right">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="86" height="87" viewBox="0 0 86 87" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M47.829 19.466C49.2121 18.0667 51.4546 18.0667 52.8377 19.466L74.0877 40.966C75.4708 42.3654 75.4708 44.6343 74.0877 46.0336L52.8377 67.5336C51.4546 68.933 49.2121 68.933 47.829 67.5336C46.4459 66.1343 46.4459 63.8654 47.829 62.466L63.033 47.0832H14.9167C12.9607 47.0832 11.375 45.4789 11.375 43.4998C11.375 41.5208 12.9607 39.9165 14.9167 39.9165H63.033L47.829 24.5336C46.4459 23.1343 46.4459 20.8654 47.829 19.466Z"
                    fill="#209FDF" />
                </svg>
              </div>
              <div class="text-title">
                {{ $vt('What\'s next ?') }}
              </div>
              <div>
                <VuePlaceholder :component="component.create" :handler="handler" :data="{ type: 'secondary' }">
                </VuePlaceholder>
              </div>
            </div>
          </div>
        </div>
      </div>
    </f-sexy-scroll>
  </div>
  <!-- <div
    class="plan-tunnel-thank-you-component"
    v-if="component.invoice_status === 'paid'"
  >
    <h1>{{ $vt('Thank you for the purchase') }}</h1>
    <f-button type="secondary" href="#/"
      ><f-icon icon="fa6-arrow-right"></f-icon> {{ $vt('Home') }}</f-button
    >
    <f-button type="primary" blank :href="component.invoice_pdf"
      ><f-icon icon="fa6-circle-down"></f-icon> {{ $vt('Download invoice') }}</f-button
    >
  </div>
  <div class="plan-tunnel-thank-you-component" v-else>
    <h1>{{ $vt('You order is still processing') }}</h1>
    <f-button type="primary" blank :href="component.hosted_invoice_url"
      ><f-icon icon="fa6-circle-down"></f-icon> {{ $vt('View payment status') }}</f-button
    >
  </div> -->
</template>

<style lang="scss">
.stripe-thank-you {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;

  .f-sexy-scroll {
    height: 100%;
    display: flex;
    justify-content: center;
    width: 100%;

    .f-sexy-scroll-inner {
      padding: 32px 0;
      box-sizing: content-box;
    }
  }

  .main-title {
    color: var(--white-a75);
    text-align: center;
    font-family: Lato;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 110%;
    /* 52.8px */
  }

  .stripe-thank-you-content {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .stripe-thank-you-detail {
    display: flex;
    gap: 32px;

    .stripe-thank-you-information {
      width: 976px;
      height: 615px;
      display: grid;
      grid-template-columns: 1fr min-content 1fr;
      grid-template-rows: 1fr min-content 1fr;

      padding: 16px;
      gap: 16px;

      // grid-template-rows: 1fr 1fr 1fr;
      align-items: center;
      justify-content: center;
      background: var(--black);
      border-radius: 12px;
      padding: 16px;
      position: relative;
      box-shadow: 0 24px 32px -8px #1616151f;




      >.center-spacer {
        grid-row: 1 / -1;
        height: 100%;

        >div {
          width: 1px;
          height: 100%;
          background-color: var(--white-a20);

        }
      }

      >.left,
      .right {
        grid-row: 1 / -1;
        display: grid;
        // grid-template-columns: subgrid;
        grid-template-rows: subgrid;
        // justify-content: center;
        justify-items: center;
        gap: 16px;

        *:first-child {
          align-self: end;
        }

        >.text-title {
          color: var(--white-a90);

          text-align: center;
          align-self: center;

          /* Headline/H4 */
          font-family: Lato;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: 110%;
          /* 26.4px */
        }
      }

      &[pending] {

        .f-form-pending {
          display: flex;
          visibility: visible;
          opacity: 1;
        }

      }

      .f-form-pending {


        display: none;
        visibility: hidden;
        opacity: 0;
        transition-property: visibility opacity;
        transition-duration: 125ms;
        transition-timing-function: ease;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
        backdrop-filter: blur(2px);
        background-color: #ffffff61;
        border-radius: 0 6px 6px 0;
      }
    }
  }

}
</style>